import transformer from '@/services/regimeTva/filtres/regimeTvaServerTableDataTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'commun/RegimeTva/';

export async function getAll(search) {
  const inputServer = transformer(search);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: id } });
  return response;
}

export async function update(regimeTva) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', regimeTva);
  return response;
}

export async function create(regimeTva) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', regimeTva);
  return response;
}

export async function archiver(params) {
  const response = await HTTP.post(URL_BASE + 'ArchiverAsync', params);
  return response;
}
